import axiosInstance from '../../../../utils/axiosInstance';

// =============================================
// USERS
// =============================================

export const getUsers = async () => {
  const { data } = await axiosInstance.get('/users/');
  return data;
};

export const createUser = async (userData) => {
  const { data } = await axiosInstance.post('/users/', userData);
  return data;
};

export const updateUser = async (userId, userData) => {
  const { data } = await axiosInstance.put(`/users/${userId}/`, userData);
  return data;
};

export const deleteUser = async (userId) => {
  const { data } = await axiosInstance.delete(`/users/${userId}/`);
  return data;
};

export const getUserLoginDetails = async (userId) => {
  const { data } = await axiosInstance.get(`/users/${userId}/login-details/`);
  return data;
};
